<div class="snackbar-confirmation-container">
    {{ data.message }}
    <div class="snackbar-confirmation-button-container">
        <app-stroked-button (onButtonClick)="onCancel()" [title]="data.cancel"></app-stroked-button>
        <app-blue-button (onButtonClick)="onAction()" [title]="data.action"></app-blue-button>
    </div>
</div>
